import type {
  AfterpayPaymentEventShape,
  EpassiPaymentEventShape,
  NetaxeptPaymentEventShape,
  NetaxeptRecurringPaymentEventShape,
  PaytrailPaymentEventShape,
  WebShopOrderDetailShape
} from 'Services/SalesManagement/Features/Order/orderSlice'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import type { FC } from 'react'
import { t } from 'ttag'
import { AfterpayPaymentInfo } from './AfterpayPaymentInfo'
import { BenefitPaymentInfo } from './BenefitPaymentInfo'
import { EpassiPaymentInfo } from './EpassiPaymentInfo'
import { NetaxeptPaymentInfo } from './NetaxeptPaymentInfo'
import { NetaxeptRecurringPaymentInfo } from './NetaxeptRecurringPaymentInfo'
import { PaytrailPaymentInfo } from './PaytrailPaymentInfo'

const WebShopOrderPaymentInfo: FC<{
  order: WebShopOrderDetailShape
}> = ({ order }) => {
  let paymentInfoComponent
  switch (order.payment_method_type) {
    case '1_paytrail_payment':
    case 'paytrail':
      paymentInfoComponent = (
        <PaytrailPaymentInfo events={order.payment_events as PaytrailPaymentEventShape[]} />
      )
      break
    case 'afterpay':
      paymentInfoComponent = (
        <AfterpayPaymentInfo events={order.payment_events as AfterpayPaymentEventShape[]} />
      )
      break
    case 'benefits':
      paymentInfoComponent = <BenefitPaymentInfo />
      break
    case 'epassi':
      paymentInfoComponent = (
        <EpassiPaymentInfo events={order.payment_events as EpassiPaymentEventShape[]} />
      )
      break
    case 'netaxept':
      paymentInfoComponent = (
        <NetaxeptPaymentInfo events={order.payment_events as NetaxeptPaymentEventShape[]} />
      )
      break
    case 'netaxept_recurring':
      paymentInfoComponent = (
        <NetaxeptRecurringPaymentInfo
          events={order.payment_events as NetaxeptRecurringPaymentEventShape[]}
        />
      )
      break
    default:
      paymentInfoComponent = null
  }
  return (
    <TableContainer component={Paper} sx={{ mb: 3 }}>
      <Table aria-label={t`Payment info table`}>{paymentInfoComponent}</Table>
    </TableContainer>
  )
}

export { WebShopOrderPaymentInfo }
